import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { Link, Redirect } from "react-router-dom";
import Axios from "axios";
import {
  FaBus,
  FaUserGraduate,
  FaSave,
  FaArrowLeft,
  FaUser,
  FaCheck,
  FaUsers,
  FaTrash,
  FaRoute,
} from "react-icons/fa";
import "../css/Admin_css/admin-customize.css";
import "../css/Admin_css/payroll.css";
import COLORS from "../resources/colors/COLORS";
import SessionManager from "../Utils/SessionManager";
import BackButton from "../ChildComponent/BackButton";
import myToast from "../Utils/MyToast";
import MyLoader from "../Spinner/MyLoader";
import MdlSelectMultipleServiceStudent from "../dialog/MdlSelectMultipleServiceStudent";

const API_BASE = `${process.env.REACT_APP_SERVER_NAME}${process.env.REACT_APP_TARGET_DIR}`;
const SERVICE_ID = "SRV001";
const HERO_GRADIENT = `linear-gradient(135deg, ${COLORS.primary_color_shade5} 0%, ${COLORS.primary_color_shade7} 55%, ${COLORS.primary_color_shade9} 100%)`;

const MONTH_NAMES = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

const MONTH_NAME_TO_NUMBER = {
  Jan: "01",
  Feb: "02",
  Mar: "03",
  Apr: "04",
  May: "05",
  Jun: "06",
  Jul: "07",
  Aug: "08",
  Sep: "09",
  Oct: "10",
  Nov: "11",
  Dec: "12",
};

const HOURS_12 = Array.from({ length: 12 }, (_, i) => String(i + 1));
const MINUTES_60 = Array.from({ length: 60 }, (_, i) =>
  String(i).padStart(2, "0")
);

function parseSessionStartDate(raw) {
  if (!raw) return null;
  const value = String(raw).trim();
  let m = value.match(/^(\d{4})-(\d{1,2})-(\d{1,2})/);
  if (m) return new Date(+m[1], +m[2] - 1, +m[3]);
  m = value.match(/^(\d{1,2})[-/](\d{1,2})[-/](\d{4})/);
  if (m) return new Date(+m[3], +m[2] - 1, +m[1]);
  const fallback = new Date(value);
  return Number.isNaN(fallback.getTime()) ? null : fallback;
}

function defaultAcademicStart() {
  const now = new Date();
  const year = now.getMonth() >= 3 ? now.getFullYear() : now.getFullYear() - 1;
  return new Date(year, 3, 1);
}

function resolveSessionStartDate(preferred) {
  const candidates = [
    preferred,
    typeof localStorage !== "undefined" ? localStorage.getItem("START_DATE") : null,
    SessionManager.getCurrentSession()?.[0]?.start_date,
  ];
  for (let i = 0; i < candidates.length; i++) {
    const parsed = parseSessionStartDate(candidates[i]);
    if (parsed) return parsed;
  }
  return defaultAcademicStart();
}

function buildSessionMonths(preferred) {
  const cal = resolveSessionStartDate(preferred);
  const y0 = cal.getFullYear();
  const m0 = cal.getMonth();
  const months = new Array(12);
  for (let i = 0; i < 12; i++) {
    const d = new Date(y0, m0 + i, 1);
    months[i] = `${MONTH_NAMES[d.getMonth()]} ${d.getFullYear()}`;
  }
  return months;
}

function reverseApplicableMonths(monthList) {
  if (!monthList?.length) return "";
  const out = [];
  for (let i = 0; i < monthList.length; i++) {
    const [monthName, year] = String(monthList[i]).split(" ");
    const month = MONTH_NAME_TO_NUMBER[monthName];
    if (month && year) out.push(`${year}-${month}`);
  }
  return out.join(",");
}

function toApiPickupTime(hour12, minute, ampm) {
  if (!hour12 || minute === "" || minute == null || !ampm) return "";
  let h = parseInt(hour12, 10);
  if (Number.isNaN(h) || h < 1 || h > 12) return "";
  const m = String(minute).padStart(2, "0");
  if (ampm === "AM") {
    if (h === 12) h = 0;
  } else if (ampm === "PM") {
    if (h !== 12) h += 12;
  } else {
    return "";
  }
  return `${h}:${m}`;
}

function studentKey(student) {
  return (
    student?.student_enrollment_no ||
    student?.student_id ||
    student?.enrollment_no ||
    ""
  );
}

function createStudentRow(student, sessionId, allMonths) {
  return {
    id: studentKey(student),
    student,
    sessionId: sessionId || student?.class?.[0]?.session_id || "",
    vehicleId: "",
    pickupPoint: "",
    pickupPointId: "",
    pickupHour: "",
    pickupMinute: "",
    pickupAmPm: "AM",
    transportFee: "",
    serviceMonths: allMonths.slice(),
  };
}

const AddTransportStudentMultiple = () => {
  const loggedIn = localStorage.getItem("token") !== null;
  const abortRef = useRef(null);

  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [saveProgress, setSaveProgress] = useState({ done: 0, total: 0 });
  const [isOpen, setIsOpen] = useState(false);

  const [routeId, setRouteId] = useState("");
  const [mRoutesList, setRoutesList] = useState([]);
  const [mVehicleList, setVehicleList] = useState([]);
  const [mAllPickupPoint, setAllPickupPoint] = useState([]);
  const [mSessionMonth, setSessionMonth] = useState([]);
  const [rows, setRows] = useState([]);
  const [invalidRowId, setInvalidRowId] = useState("");

  const pickupByName = useMemo(() => {
    const map = new Map();
    for (let i = 0; i < mAllPickupPoint.length; i++) {
      const point = mAllPickupPoint[i];
      const name = String(point.pickup_point_name || "")
        .trim()
        .toLowerCase();
      if (name) map.set(name, point.pickup_point_id || "");
    }
    return map;
  }, [mAllPickupPoint]);

  const selectedRoute = useMemo(
    () => mRoutesList.find((r) => r.route_id === routeId) || null,
    [mRoutesList, routeId]
  );

  const getTransportSetupData = useCallback(async () => {
    if (abortRef.current) abortRef.current.abort();
    const controller = new AbortController();
    abortRef.current = controller;

    setLoading(true);
    const schoolCode = SessionManager.getSchoolCode();
    if (!schoolCode) {
      setLoading(false);
      myToast.notify_warning("School code is missing.");
      return;
    }

    try {
      const response = await Axios.get(`${API_BASE}getTransportSetupData.php`, {
        params: { school_code: schoolCode },
        signal: controller.signal,
      });
      if (controller.signal.aborted) return;

      if (response.data?.api_status === "OK") {
        const data = response.data.data || {};
        setRoutesList(data.routes || []);
        setAllPickupPoint(data.PickupPoints || []);
        setVehicleList(data.VehicleList || []);
      } else {
        setRoutesList([]);
        setAllPickupPoint([]);
        setVehicleList([]);
        myToast.notify_warning(
          response.data?.api_remark || "Could not load transport setup."
        );
      }
    } catch (error) {
      if (
        Axios.isCancel?.(error) ||
        error?.name === "CanceledError" ||
        error?.code === "ERR_CANCELED"
      ) {
        return;
      }
      console.error(error);
      myToast.notify_warning("Network error loading transport setup.");
    } finally {
      if (!controller.signal.aborted) setLoading(false);
    }
  }, []);

  useEffect(() => {
    getTransportSetupData();
    const start =
      SessionManager.getCurrentSession()?.[0]?.start_date ||
      localStorage.getItem("START_DATE") ||
      "";
    setSessionMonth(buildSessionMonths(start));
    return () => {
      if (abortRef.current) abortRef.current.abort();
    };
  }, [getTransportSetupData]);

  const handleRouteSelect = useCallback((id) => {
    setRouteId((prev) => (prev === id ? "" : id));
  }, []);

  const openStudentModal = useCallback(() => {
    if (!routeId) {
      myToast.notify_warning("Select a route first");
      return;
    }
    setIsOpen(true);
  }, [routeId]);

  const handleCloseModal = useCallback(() => setIsOpen(false), []);

  const handleStudentsDone = useCallback(
    (selectedStudents, sessionId, _sessionName, sessionStartDate) => {
      setIsOpen(false);
      const months = buildSessionMonths(sessionStartDate);
      setSessionMonth(months);

      setRows((prev) => {
        const existing = new Map(prev.map((r) => [r.id, r]));
        const next = [...prev];
        (selectedStudents || []).forEach((student) => {
          const id = studentKey(student);
          if (!id || existing.has(id)) return;
          next.push(createStudentRow(student, sessionId, months));
        });
        return next;
      });
    },
    []
  );

  const removeRow = useCallback((id) => {
    setRows((prev) => prev.filter((r) => r.id !== id));
  }, []);

  const updateRow = useCallback(
    (id, patch) => {
      setInvalidRowId((prev) => (prev === id ? "" : prev));
      setRows((prev) =>
        prev.map((row) => {
          if (row.id !== id) return row;
          const next = { ...row, ...patch };
          if (Object.prototype.hasOwnProperty.call(patch, "pickupPoint")) {
            next.pickupPointId =
              pickupByName.get(
                String(patch.pickupPoint || "").trim().toLowerCase()
              ) || "";
          }
          return next;
        })
      );
    },
    [pickupByName]
  );

  const toggleRowMonth = useCallback((id, month) => {
    setInvalidRowId((prev) => (prev === id ? "" : prev));
    setRows((prev) =>
      prev.map((row) => {
        if (row.id !== id) return row;
        const has = row.serviceMonths.includes(month);
        return {
          ...row,
          serviceMonths: has
            ? row.serviceMonths.filter((m) => m !== month)
            : [...row.serviceMonths, month],
        };
      })
    );
  }, []);

  const toggleAllRowMonths = useCallback(
    (id) => {
      setInvalidRowId((prev) => (prev === id ? "" : prev));
      setRows((prev) =>
        prev.map((row) => {
          if (row.id !== id) return row;
          const allOn =
            mSessionMonth.length > 0 &&
            row.serviceMonths.length === mSessionMonth.length;
          return {
            ...row,
            serviceMonths: allOn ? [] : mSessionMonth.slice(),
          };
        })
      );
    },
    [mSessionMonth]
  );

  const isValidInput = useCallback(() => {
    setInvalidRowId("");

    if (!routeId) {
      myToast.notify_warning("Select a route");
      return false;
    }
    if (!rows.length) {
      myToast.notify_warning("Select at least one student");
      return false;
    }

    for (let i = 0; i < rows.length; i++) {
      const row = rows[i];
      const name = row.student?.stu_name || row.id || `Student ${i + 1}`;
      const cls = row.student?.class?.[0] || {};
      const sessionId = row.sessionId || cls.session_id || "";
      const classId = cls.class_id || "";
      const sectionId = cls.section_id || "";
      const pickupPoint = String(row.pickupPoint || "").trim();
      const feeRaw = String(row.transportFee ?? "").trim();
      const feeNum = Number(feeRaw);
      const pickupTime = toApiPickupTime(
        row.pickupHour,
        row.pickupMinute,
        row.pickupAmPm
      );

      const fail = (message) => {
        setInvalidRowId(row.id);
        myToast.notify_warning(message);
        requestAnimationFrame(() => {
          const el = document.getElementById(`atsm-row-${row.id}`);
          if (el?.scrollIntoView) {
            el.scrollIntoView({ behavior: "smooth", block: "center" });
          }
        });
        return false;
      };

      if (!sessionId || !classId || !sectionId) {
        return fail(`Class/session missing for ${name}. Re-select the student.`);
      }
      if (!pickupPoint) {
        return fail(`Enter pickup point for ${name}`);
      }
      if (!row.vehicleId) {
        return fail(`Select vehicle for ${name}`);
      }
      if (!row.pickupHour || row.pickupMinute === "" || row.pickupMinute == null) {
        return fail(`Select pickup time for ${name}`);
      }
      if (!pickupTime) {
        return fail(`Invalid pickup time for ${name}`);
      }
      if (!feeRaw) {
        return fail(`Enter transport fee for ${name}`);
      }
      if (!Number.isFinite(feeNum) || feeNum < 0) {
        return fail(`Enter a valid transport fee (≥ 0) for ${name}`);
      }
      if (!row.serviceMonths?.length) {
        return fail(`Select service months for ${name}`);
      }
    }
    return true;
  }, [routeId, rows]);

  const handleSubmit = useCallback(async () => {
    if (!isValidInput()) return;

    const schoolCode = SessionManager.getSchoolCode();
    const staffId = SessionManager.getStaffDetails()?.staff_id;
    if (!schoolCode || !staffId) {
      myToast.notify_warning("Staff or school details missing");
      return;
    }

    const studentsPayload = rows.map((row) => {
      const student = row.student;
      const cls = student?.class?.[0] || {};
      const pickupTime = toApiPickupTime(
        row.pickupHour,
        row.pickupMinute,
        row.pickupAmPm
      );
      const resolvedPickupPointId =
        row.pickupPointId ||
        pickupByName.get(String(row.pickupPoint || "").trim().toLowerCase()) ||
        "";

      return {
        student_id: row.id,
        session_id: row.sessionId || cls.session_id || "",
        class_id: cls.class_id || "",
        section_id: cls.section_id || "",
        vehicle_id: row.vehicleId,
        pickup_point_id: resolvedPickupPointId,
        pickup_point_name: String(row.pickupPoint || "").trim(),
        pickup_time: pickupTime,
        transport_fee: String(Number(row.transportFee)),
        concession_granted: "No",
        applicable_month: reverseApplicableMonths(row.serviceMonths),
      };
    });

    setSaving(true);
    setSaveProgress({ done: 0, total: studentsPayload.length });

    try {
      const params = new URLSearchParams({
        staff_id: staffId,
        route_id: routeId,
        service_id: SERVICE_ID,
        school_code: schoolCode,
        students: JSON.stringify(studentsPayload),
      });

      const response = await Axios.post(
        `${API_BASE}addTransportStudentMultiple.php`,
        params,
        { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
      );

      const data = response.data?.data || {};
      const okCount = Number(data.successCount || 0);
      const failCount = Number(data.errorCount || 0);
      const failedIds = (data.failed || [])
        .map((f) => f.student_id)
        .filter(Boolean);

      setSaveProgress({
        done: studentsPayload.length,
        total: studentsPayload.length,
      });

      if (response.data?.api_status === "OK" && okCount > 0 && failCount === 0) {
        myToast.notify_success(`Added ${okCount} student(s) to transport.`);
        setInvalidRowId("");
        setRows([]);
      } else if (response.data?.api_status === "OK" && okCount > 0) {
        myToast.notify_warning(
          `Added ${okCount}, failed ${failCount}. Review remaining students.`
        );
        setRows((prev) => prev.filter((r) => failedIds.includes(r.id)));
        if (failedIds[0]) setInvalidRowId(failedIds[0]);
      } else {
        myToast.notify_error(
          response.data?.api_remark || "Failed to add transport students."
        );
      }
    } catch (error) {
      console.error("addTransportStudentMultiple error:", error);
      myToast.notify_error("Failed to add transport students.");
    } finally {
      setSaving(false);
    }
  }, [isValidInput, rows, pickupByName, routeId]);

  if (!loggedIn) return <Redirect to="/Login" />;

  return (
    <div
      className="content payroll-page sm-page sr-page ats-page atsm-page"
      style={{
        background: COLORS.white,
        fontFamily:
          'Inter, system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
      }}
    >
      {isOpen ? (
        <MdlSelectMultipleServiceStudent
          serviceId={SERVICE_ID}
          initiallySelected={rows.map((r) => r.student)}
          actionClose={handleCloseModal}
          actionDone={handleStudentsDone}
        />
      ) : null}

      <div
        className="content-header"
        style={{ background: COLORS.primary_color_shade5 }}
      >
        <div className="leftside-content-header">
          <ul className="breadcrumbs">
            <li>
              <i
                className="fa fa-home"
                aria-hidden="true"
                style={{ color: COLORS.white }}
              />
              <span style={{ color: COLORS.white }}>
                {" "}
                Add Multiple Transport Students
              </span>
            </li>
          </ul>
        </div>
        <div className="rightside-content-header">
          <BackButton />
        </div>
      </div>

      <div className="bg_page_white_rounded box_shadow animated fadeInUp sm-shell">
        <header className="sm-hero" style={{ "--sm-hero-bg": HERO_GRADIENT }}>
          <div className="sm-hero__brand">
            <div className="sm-hero__icon" aria-hidden>
              <FaUsers />
            </div>
            <div className="min-w-0">
              <h1 className="sm-hero__title">Add Multiple Students</h1>
              <p className="sm-hero__sub">
                Choose route, select students, then set pickup, vehicle, fee &
                months
              </p>
            </div>
          </div>
          <div className="sm-hero__tools">
            <Link to="/AdminMain/TransportStudent" className="ats-hero-link">
              <FaArrowLeft aria-hidden /> Students
            </Link>
            <Link to="/AdminMain/AddTransportStudent" className="ats-hero-link">
              Single add
            </Link>
          </div>
        </header>

        {loading ? (
          <div className="ats-loading">
            <MyLoader />
          </div>
        ) : (
          <div className="sr-body ats-body">
            <section className="sr-section ats-section ats-section--transport">
              <div className="sr-section__head">
                <div className="sr-section__icon" aria-hidden>
                  <FaRoute />
                </div>
                <div className="min-w-0">
                  <h2 className="sr-section__title">Select route</h2>
                  <p className="sr-section__sub">
                    {selectedRoute
                      ? `Selected: ${selectedRoute.route_name}`
                      : "Tap a route chip to continue"}
                  </p>
                </div>
              </div>
              <div className="sr-section__body">
                {mRoutesList.length === 0 ? (
                  <div className="ats-student-empty">
                    <div className="ats-student-empty__icon" aria-hidden>
                      <FaRoute />
                    </div>
                    <p>No routes found. Add routes in transport setup.</p>
                  </div>
                ) : (
                  <div className="atsm-route-chips" role="group" aria-label="Routes">
                    {mRoutesList.map((route) => {
                      const active = routeId === route.route_id;
                      return (
                        <button
                          key={route.route_id}
                          type="button"
                          className={`atsm-route-chip${active ? " is-active" : ""}`}
                          onClick={() => handleRouteSelect(route.route_id)}
                        >
                          {active ? <FaCheck aria-hidden /> : <FaBus aria-hidden />}
                          <span>{route.route_name}</span>
                        </button>
                      );
                    })}
                  </div>
                )}
              </div>
            </section>

            <section className="sr-section ats-section ats-section--student">
              <div className="sr-section__head">
                <div className="sr-section__icon" aria-hidden>
                  <FaUserGraduate />
                </div>
                <div className="min-w-0">
                  <h2 className="sr-section__title">Students</h2>
                  <p className="sr-section__sub">
                    {rows.length
                      ? `${rows.length} student${rows.length === 1 ? "" : "s"} selected`
                      : "Select multiple students after choosing a route"}
                  </p>
                </div>
                <button
                  type="button"
                  className="atsm-select-btn"
                  onClick={openStudentModal}
                  disabled={!routeId}
                >
                  <span className="atsm-select-btn__icon" aria-hidden>
                    <FaUsers />
                  </span>
                  <span className="atsm-select-btn__text">
                    <span className="atsm-select-btn__title">
                      {rows.length
                        ? "Add More Students"
                        : "Select Multiple Students"}
                    </span>
                    {rows.length > 0 ? (
                      <span className="atsm-select-btn__hint">
                        {rows.length} already selected
                      </span>
                    ) : null}
                  </span>
                </button>
              </div>
              <div className="sr-section__body">
                {!routeId ? (
                  <div className="ats-student-empty">
                    <div className="ats-student-empty__icon" aria-hidden>
                      <FaRoute />
                    </div>
                    <p>Select a route first</p>
                  </div>
                ) : rows.length === 0 ? (
                  <div className="ats-student-empty">
                    <div className="ats-student-empty__icon" aria-hidden>
                      <FaUserGraduate />
                    </div>
                    <p>No students selected yet. Use Select Multiple Students.</p>
                  </div>
                ) : (
                  <div className="atsm-row-list">
                    {rows.map((row, index) => {
                      const student = row.student;
                      const cls = student?.class?.[0];
                      const classLabel = cls
                        ? cls.section_id === "No"
                          ? cls.class_name || "—"
                          : `${cls.class_name || "—"}:${cls.section_name || "—"}`
                        : "—";
                      const monthSet = new Set(row.serviceMonths);
                      const allMonthsOn =
                        mSessionMonth.length > 0 &&
                        row.serviceMonths.length === mSessionMonth.length;

                      return (
                        <article
                          key={row.id}
                          id={`atsm-row-${row.id}`}
                          className={`atsm-row${
                            invalidRowId === row.id ? " is-invalid" : ""
                          }`}
                        >
                          <div className="atsm-row__body">
                            <div className="atsm-row__left">
                              <div className="atsm-row__head">
                                <div className="atsm-row__identity">
                                  <span className="atsm-row__index" aria-hidden>
                                    {index + 1}
                                  </span>
                                  <span className="atsm-row__avatar" aria-hidden>
                                    {student?.student_img_path ? (
                                      <img
                                        src={student.student_img_path}
                                        alt=""
                                        onError={(e) => {
                                          e.currentTarget.style.display = "none";
                                        }}
                                      />
                                    ) : (
                                      <FaUser />
                                    )}
                                  </span>
                                  <div className="min-w-0">
                                    <h3 className="atsm-row__name">
                                      {student?.stu_name || "Student"}
                                    </h3>
                                    <p className="atsm-row__meta">
                                      {classLabel}
                                      {student?.student_enrollment_no
                                        ? ` · ${student.student_enrollment_no}`
                                        : ""}
                                      {cls?.student_roll_no
                                        ? ` · Roll ${cls.student_roll_no}`
                                        : ""}
                                    </p>
                                  </div>
                                </div>
                                <button
                                  type="button"
                                  className="atsm-row__remove"
                                  onClick={() => removeRow(row.id)}
                                  title="Remove student"
                                >
                                  <FaTrash aria-hidden />
                                </button>
                              </div>

                              <div className="atsm-row__left-top">
                                <div className="sr-field">
                                  <label
                                    className="sr-field__label"
                                    htmlFor={`atsm-pickup-${row.id}`}
                                  >
                                    Pickup point{" "}
                                    <span className="sr-field__req">*</span>
                                  </label>
                                  <input
                                    id={`atsm-pickup-${row.id}`}
                                    className="form-control sr-input"
                                    list={`atsm-pickup-list-${row.id}`}
                                    value={row.pickupPoint}
                                    onChange={(e) =>
                                      updateRow(row.id, {
                                        pickupPoint: e.target.value,
                                      })
                                    }
                                    placeholder="Type or select pickup point"
                                    autoComplete="off"
                                  />
                                  <datalist id={`atsm-pickup-list-${row.id}`}>
                                    {mAllPickupPoint.map((point) => (
                                      <option
                                        key={point.pickup_point_id}
                                        value={point.pickup_point_name}
                                      />
                                    ))}
                                  </datalist>
                                </div>

                                <div className="sr-field">
                                  <label
                                    className="sr-field__label"
                                    htmlFor={`atsm-vehicle-${row.id}`}
                                  >
                                    Vehicle{" "}
                                    <span className="sr-field__req">*</span>
                                  </label>
                                  <select
                                    id={`atsm-vehicle-${row.id}`}
                                    className="form-control sr-input"
                                    value={row.vehicleId}
                                    onChange={(e) =>
                                      updateRow(row.id, {
                                        vehicleId: e.target.value,
                                      })
                                    }
                                  >
                                    <option value="">Select vehicle</option>
                                    {mVehicleList.map((item) => (
                                      <option
                                        key={item.vehicle_id}
                                        value={item.vehicle_id}
                                      >
                                        {item.vehicle_name ||
                                          item.vehicle_number}{" "}
                                        ({item.vehicle_type || "—"})
                                      </option>
                                    ))}
                                  </select>
                                </div>
                              </div>

                              <div className="sr-field">
                                <label
                                  className="sr-field__label"
                                  htmlFor={`atsm-hour-${row.id}`}
                                >
                                  Pickup time{" "}
                                  <span className="sr-field__req">*</span>
                                </label>
                                <div
                                  className="ats-time-12"
                                  role="group"
                                  aria-label="Pickup time"
                                >
                                  <select
                                    id={`atsm-hour-${row.id}`}
                                    className="form-control sr-input"
                                    value={row.pickupHour}
                                    onChange={(e) =>
                                      updateRow(row.id, {
                                        pickupHour: e.target.value,
                                      })
                                    }
                                  >
                                    <option value="">Hour</option>
                                    {HOURS_12.map((h) => (
                                      <option key={h} value={h}>
                                        {h}
                                      </option>
                                    ))}
                                  </select>
                                  <span className="ats-time-12__sep" aria-hidden>
                                    :
                                  </span>
                                  <select
                                    className="form-control sr-input"
                                    value={row.pickupMinute}
                                    onChange={(e) =>
                                      updateRow(row.id, {
                                        pickupMinute: e.target.value,
                                      })
                                    }
                                  >
                                    <option value="">Min</option>
                                    {MINUTES_60.map((m) => (
                                      <option key={m} value={m}>
                                        {m}
                                      </option>
                                    ))}
                                  </select>
                                  <select
                                    className="form-control sr-input"
                                    value={row.pickupAmPm}
                                    onChange={(e) =>
                                      updateRow(row.id, {
                                        pickupAmPm: e.target.value,
                                      })
                                    }
                                  >
                                    <option value="AM">AM</option>
                                    <option value="PM">PM</option>
                                  </select>
                                </div>
                              </div>
                            </div>

                            <div className="atsm-row__right">
                              <div className="sr-field">
                                <label
                                  className="sr-field__label"
                                  htmlFor={`atsm-fee-${row.id}`}
                                >
                                  Transport fee{" "}
                                  <span className="sr-field__req">*</span>
                                </label>
                                <div className="ats-fee-input-wrap">
                                  <span className="ats-fee-prefix" aria-hidden>
                                    ₹
                                  </span>
                                  <input
                                    id={`atsm-fee-${row.id}`}
                                    type="number"
                                    min="0"
                                    className="form-control sr-input ats-fee-input"
                                    value={row.transportFee}
                                    onChange={(e) =>
                                      updateRow(row.id, {
                                        transportFee: e.target.value,
                                      })
                                    }
                                    placeholder="0"
                                  />
                                </div>
                              </div>

                              <div className="atsm-row__months">
                                <div className="ats-months-box__head">
                                  <span className="sr-field__label">
                                    Service months{" "}
                                    <span className="sr-field__req">*</span>
                                  </span>
                                  <button
                                    type="button"
                                    className="ats-months-toggle"
                                    onClick={() => toggleAllRowMonths(row.id)}
                                  >
                                    {allMonthsOn ? "Clear all" : "Select all"}
                                  </button>
                                </div>
                                <div className="ats-months" role="group">
                                  {mSessionMonth.map((month) => {
                                    const active = monthSet.has(month);
                                    const shortLabel = String(month).replace(
                                      / (\d{2})(\d{2})$/,
                                      " '$2"
                                    );
                                    return (
                                      <button
                                        key={month}
                                        type="button"
                                        className={`ats-month${
                                          active ? " is-active" : ""
                                        }`}
                                        onClick={() =>
                                          toggleRowMonth(row.id, month)
                                        }
                                        title={month}
                                      >
                                        {active ? (
                                          <FaCheck aria-hidden />
                                        ) : null}
                                        {shortLabel}
                                      </button>
                                    );
                                  })}
                                </div>
                              </div>
                            </div>
                          </div>
                        </article>
                      );
                    })}
                  </div>
                )}
              </div>
            </section>

            {rows.length > 0 ? (
              <div className="ats-actions">
                <Link
                  to="/AdminMain/TransportStudent"
                  className="sr-btn sr-btn--ghost ats-btn-cancel"
                >
                  Cancel
                </Link>
                <button
                  type="button"
                  className="sr-btn sr-btn--primary ats-btn-submit"
                  onClick={handleSubmit}
                  disabled={saving}
                >
                  <FaSave aria-hidden />
                  {saving
                    ? `Saving ${saveProgress.done}/${saveProgress.total}…`
                    : `Add ${rows.length} Student${rows.length === 1 ? "" : "s"}`}
                </button>
              </div>
            ) : null}
          </div>
        )}
      </div>
    </div>
  );
};

export default AddTransportStudentMultiple;
